import React, { useEffect } from "react";
import { Column } from "@amzn/meridian";
import { useAppDispatch, useAppSelector } from "src/store/store";
import QuestionDisplayCard from "./questionDisplayCard";
import { useParams } from "react-router-dom";
import { setSelectedInspectionTemplate } from "src/store/dataSlice";

const QuestionsList = () => {
  const { inspectionTemplates, selectedInspectionTemplate } = useAppSelector(
    (state) => state.data
  );
  const { templateId } = useParams();
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (!selectedInspectionTemplate && templateId) {
      const template = inspectionTemplates.find(
        (temp) => temp.templateId === templateId
      );
      if (template) dispatch(setSelectedInspectionTemplate(template));
    }
  }, [selectedInspectionTemplate, templateId, inspectionTemplates]);

  return (
    <Column>
      {selectedInspectionTemplate?.questions?.map((question, index) => (
        <QuestionDisplayCard
          key={question.questionId}
          question={question}
          questionOrder={index + 1}
        />
      ))}
    </Column>
  );
};

export default QuestionsList;
